import React from "react";

const Java_Float = () => {
  return (
    <div>
      <h1>Java Float</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Float in Java.</p>
    </div>
  );
};

export default Java_Float;
